// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"579":"83a6a05c","799":"b49a9ad5"}[chunkId] + ".chunk.css";
};